module.exports = __webpack_public_path__ + "27269687de5dd1484f58e9ea59e78cad.png";